// @vendors
const Immutable = require('immutable');
const { get } = require('lodash');
const trim = require('lodash/string/trim');

// @ constants
const { CM_SYNC } = require('../constants/actionTypes');
const actionTypes = require('../constants/actionTypes');
const { OKCONSENTS_RESET } = require('gdpr-consents/constants/actionTypes');
const {
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP,
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP,
    WIZARD_THIRD_STEP,
} = require('constants/index');
const {
    CM_ACTIVE_FUND_TYPE,
    CM_PASIVE_FUND_TYPE,
    CM_PUBLIC_ACTIVE_FUND_TYPE,
    CM_ACTIVE_FUND_TYPE_TAG,
    CM_PASIVE_FUND_TYPE_TAG,
    CM_DIY_TAG,
    CM_TRANSFER_TAX_EXEMPT_FALSE,
    CM_BUY_TYPE_MONEY,
    CM_CUSTOMIZED,
} = require('../constants/constants');
const { INTERVENER_CODES_BY_DESCRIPTION } = require('constants/interveners');
// @ reducers
const cmWalletBuyStep1 = require('./cmWalletBuy/cmWalletBuyStep1');
const cmWalletBuyStep2 = require('./cmWalletBuy/cmWalletBuyStep2');
const cmWalletBuyStep3 = require('./cmWalletBuy/cmWalletBuyStep3');

const initialState = () => {
    return Immutable.Map().merge({
        simulation: {
            id: '',
            type: '',
            publicAmount: 0,
            amount: 0,
            returnPath: '',
        },
        steps: [
            cmWalletBuyStep1(undefined, { type: null }),
            cmWalletBuyStep2(undefined, { type: null }),
            cmWalletBuyStep3(undefined, { type: null }),
        ],
        walletRisk: {
            mostRestrictiveIsin: '',
            riskPortfolioCategorization: '',
            riskPortfolioMiFid2: '',
        },
        errorReceived: '',
        isFetching: false,
        isFetchingSuccess: false,
        inProgress: false,
        willLeave: false,
        visibleStep: WIZARD_FIRST_STEP,
        submitSuccessful: false,
        isFetchingPortfolioInfo: false,
        isFetchingRiskCategorizationPortfolio: false,
        isFetchingFundsMinAmounts: false,
        isPortfolioInfoFetched: false,
        isRiskPortfolioCategorizationFetched: false,
        isFundsMinAmountsFetched: false,
        isSynchronized: false,
        isMinFundAmountValid: false,
        portfolios: [],
        orderValidation: {},
        minAmounts: [],
        minAmountsCurrency: '',
        error: '',
        buyType: CM_BUY_TYPE_MONEY,
        originFund: '',
        orderConfirmationSuccessful: [],
        orderConfirmationNotSuccessful: [],
        errorValidation: false,
        errorConfirmation: false,
        preLeaveModalOpen: false,
        eventTag: '',
    });
};

function updateStep(index, steps, action) {
    return steps.update(index, step => {
        switch (index) {
            case FIRST_STEP:
                return cmWalletBuyStep1(step, action);
            case SECOND_STEP:
                return cmWalletBuyStep2(step, action);
            case THIRD_STEP:
                return cmWalletBuyStep3(step, action);
        }
    });
}

function formatFundType(fundType) {
    return fundType === CM_PUBLIC_ACTIVE_FUND_TYPE
        ? CM_ACTIVE_FUND_TYPE
        : CM_PASIVE_FUND_TYPE;
}

function filterPortfoliosByType(portfolios, type) {
    get(portfolios, '[0].assetClassInfo', []).forEach(aci => {
        get(aci, 'subAssetClassInfo', []).forEach(saci => {
            const filtered = get(saci, 'subAssetClassIsinInfo', []).filter(
                sacii => get(sacii, 'subAssetClassIndIsin') === type,
            );
            saci.subAssetClassIsinInfo = filtered;
        });
    });

    return portfolios;
}

/*function formatConfimation(funds) {
    const assetsById = {};
    funds.forEach(fund => {
        if (assetsById[fund.assetClassId]) {
            return;
        }

        assetsById[fund.assetClassId] = {
            assetClassDesc: fund.assetClassDesc,
            assetClassId: fund.assetClassId,
            subAssetClassInfo: []
        };
    });

    funds.forEach((fund)=>{
        assetsById[fund.assetClassId].subAssetClassInfo.push({
            subAssetClassDesc: fund.subAssetClassDesc,
            subAssetClassId: fund.subAssetClassId,
            subAssetClassIsinInfo: [{
                subAssetClassFundName: fund.subAssetClassFundsName,
                subAssetClassDesc: fund.subAssetClassDesc,
                subAssetClassFundAmount: fund.subAssetClassFundAmount,
                currency: fund.currency,
                subAssetClassIsin: fund.subAssetClassIsin
            }]
        });
    });

    return {
        assetClassInfo: Object.values(assetsById),
    };
}*/

function getEventTag(filteredPortfolios, type, isDiy) {
    const portfolioName =
        isDiy === CM_CUSTOMIZED
            ? CM_DIY_TAG
            : filteredPortfolios[0].portfolioDesc;
    const typeTag =
        type === CM_ACTIVE_FUND_TYPE
            ? CM_ACTIVE_FUND_TYPE_TAG
            : CM_PASIVE_FUND_TYPE_TAG;
    return `${portfolioName.toLowerCase()}-${typeTag}`;
}

function validateMinFundsAmount(funds, minAmounts, isFundsMinAmountsFetched) {
    let isValid = true;

    if (!isFundsMinAmountsFetched) {
        return { isValid: false, portfolio: funds };
    }

    if (minAmounts && minAmounts.length > 0) {
        funds.assetClassInfo.forEach(asset => {
            const subClasses = asset.subAssetClassInfo;
            subClasses.forEach(subClass => {
                const subAssets = subClass.subAssetClassIsinInfo;
                subAssets.forEach(subAsset => {
                    const fundMinAmount = minAmounts.find(
                        x => x.isin == subAsset.subAssetClassIsin,
                    );
                    if (fundMinAmount) {
                        const isFundValid =
                            subAsset.subAssetClassFundAmount >=
                            fundMinAmount.minimumAmount;
                        subAsset.isValidAmount = isFundValid;
                        isValid = isValid && isFundValid;
                        subAsset.fundMinAmount = fundMinAmount.minimumAmount;
                    }
                });
            });
        });
    }

    return { isValid, portfolio: funds };
}

const filterAvailables = (
    currentInterveners = [],
    originalInterveners = [],
) => {
    const availableInterveners = originalInterveners.filter(intervener => {
        return !currentInterveners.find(originalIntervener => {
            return intervener.get('name') === originalIntervener.get('name');
        });
    });
    return availableInterveners;
};

const updateIntervener = (immState, payload) => {
    const intervenerIndex = get(payload, 'index');
    const intervenerDescription = trim(get(payload, 'type'));
    const intervenerType = trim(
        INTERVENER_CODES_BY_DESCRIPTION[intervenerDescription],
    );

    return immState.mergeDeepIn(['steps', 0, 'interveners', intervenerIndex], {
        type: intervenerDescription,
        interventionType: intervenerType,
    });
};

const cmReducer = (state = initialState(), action) => {
    let visibleStep, partialSteps;
    switch (action.type) {
        case CM_SYNC:
            return state.merge({
                simulation: {
                    id: action.payload.id,
                    type: formatFundType(action.payload.type),
                    publicAmount: action.payload.amount,
                    amount: action.payload.amount,
                    isDiy: action.payload.isDiy,
                    returnPath: action.payload.returnUrl,
                },
                isSynchronized: true,
            });
        case actionTypes.CM_SET_VISIBLE_STEP:
            return state.merge({
                visibleStep: action.payload.step,
            });
        case actionTypes.CM_WILL_CANCEL:
        case actionTypes.CM_WILL_LEAVE:
            return state.merge({
                willLeave: true,
            });
        case actionTypes.CM_BUY_TYPE_CHANGED:
            partialSteps = updateStep(FIRST_STEP, state.get('steps'), action);
            return state.merge({
                buyType: action.payload.data,
                steps: partialSteps,
            });
        case actionTypes.BROKER_WIZARD_INTERNAL_TRANSFER_SET_ORIGIN_FUND_ID:
            const selectionFundsInfo = state.getIn([
                'steps',
                '0',
                'selectionFundsInfo',
            ]);
            const selectFund = selectionFundsInfo.find(
                fund =>
                    fund.getIn([
                        'infoFondosOutput',
                        'infoFondosPosicionGlobal',
                        'contrato',
                        'numeroContrato',
                    ]) === action.payload.fundId,
            );
            if (
                selectFund &&
                selectFund.getIn(['infoFondosOutput', 'transferTaxExempt']) !=
                    CM_TRANSFER_TAX_EXEMPT_FALSE
            ) {
                return state.merge({
                    originFund: action.payload.fundId,
                });
            }
            return state;
        case actionTypes.CM_RESET_ORIGIN_FUND:
            return state.set('originFund', '');
        case actionTypes.CM_TRANSFER_MONEY_VALIDATE_STEP:
        case actionTypes.CM_VALIDATE_STEP:
        case actionTypes.CM_FROM_FUNDS_VALIDATE_STEP:
            switch (state.get('visibleStep')) {
                case WIZARD_FIRST_STEP:
                    const portfolio = state.getIn(['portfolios', 0]);
                    const validMinFundsAmount = validateMinFundsAmount(
                        portfolio.toJS(),
                        state.get('minAmounts').toJS(),
                        state.get('isFundsMinAmountsFetched'),
                    );
                    partialSteps = updateStep(
                        FIRST_STEP,
                        state.get('steps'),
                        action,
                    );
                    visibleStep =
                        partialSteps.getIn([FIRST_STEP, 'valid']) &&
                        validMinFundsAmount &&
                        partialSteps.getIn([SECOND_STEP, 'validFromCalculator'])
                            ? WIZARD_SECOND_STEP
                            : WIZARD_FIRST_STEP;

                    return state
                        .setIn(
                            ['portfolios', 0],
                            Immutable.fromJS(validMinFundsAmount.portfolio),
                        )
                        .merge({
                            steps: partialSteps,
                            visibleStep,
                            isMinFundAmountValid: validMinFundsAmount.isValid,
                        });
                case WIZARD_SECOND_STEP:
                    partialSteps = updateStep(
                        SECOND_STEP,
                        state.get('steps'),
                        action,
                    );
                    visibleStep =
                        partialSteps.getIn([SECOND_STEP, 'valid']) &&
                        partialSteps.getIn([THIRD_STEP, 'validFromAPI'])
                            ? WIZARD_THIRD_STEP
                            : WIZARD_SECOND_STEP;
                    return state.merge({
                        steps: partialSteps,
                        visibleStep,
                    });
                case WIZARD_THIRD_STEP:
                    partialSteps = updateStep(
                        THIRD_STEP,
                        state.get('steps'),
                        action,
                    );
                    return state.merge({
                        steps: partialSteps,
                    });
                default:
                    return state;
            }
        case actionTypes.CM_FILTER_BY_ASSOCIATED_ACCOUNT:
        case actionTypes.CM_SAVE_ORIGIN_FUND_INFO:
        case actionTypes.CM_RUN_CALCULATOR_SERVICE_REQUEST:
        case actionTypes.CM_RUN_CALCULATOR_SERVICE_FAILURE:
        case actionTypes.FETCH_CM_CONTRACTS_ORIGIN_TRANSFER_REQUEST:
        case actionTypes.FETCH_CM_CONTRACTS_ORIGIN_TRANSFER_SUCCESS:
        case actionTypes.CM_GET_INTERVENERS_SUCCESS:
        case actionTypes.CM_RESTORE_DEFAULT_INTERVENERS:
        case actionTypes.CM_SET_ACCOUNT_INTERVENER_NAME:
        case actionTypes.CM_SET_ACCOUNT_INTERVENER_TYPE:
        case actionTypes.CM_SET_ACCOUNT:
        case actionTypes.CM_DISABLE_NEXT_BUTTON:
        case actionTypes.CM_ENABLE_NEXT_BUTTON:
        case actionTypes.CM_SET_ACCOUNT_CHANGED:
        case actionTypes.CM_SET_AMOUNT:
        case actionTypes.CM_SET_INITIAL_AMOUNT:
        case actionTypes.CM_GET_PORTFOLIOS_LIST_REQUEST:
        case actionTypes.CM_GET_PORTFOLIOS_LIST_ERROR:
        case actionTypes.CM_GET_PORTFOLIOS_LIST_SUCCESS:
        case actionTypes.CM_FILTER_CHANGE_WALLET:
        case actionTypes.CM_SET_FUND_ID_MATCHED_IN_PORTFOLIO:
            partialSteps = updateStep(FIRST_STEP, state.get('steps'), action);
            return state.merge({
                steps: partialSteps,
            });
        case actionTypes.CM_RUN_ORCHESTRATOR_SERVICE_SUCCESS:
            const portfolioTransferConfirmationOutput =
                action.payload.data.portfolioTransferConfirmationOutput;
            const emptyTransferOrderResultOkOutput =
                portfolioTransferConfirmationOutput.transferOrderResultOkOutput
                    .length === 0;

            partialSteps = updateStep(THIRD_STEP, state.get('steps'), action);
            return state.merge({
                steps: partialSteps,
                errorConfirmation: emptyTransferOrderResultOkOutput,
            });
        case actionTypes.CM_RUN_ORCHESTRATOR_SERVICE_REQUEST:
        case actionTypes.CM_RUN_ORCHESTRATOR_SERVICE_FAILURE:
            partialSteps = updateStep(THIRD_STEP, state.get('steps'), action);
            return state.merge({
                steps: partialSteps,
            });
        case actionTypes.CM_GET_INTERVENERS_REQUEST:
            return state.merge({
                isFetching: true,
            });
        case actionTypes.CM_GET_INTERVENERS_ERROR:
            return state.merge({
                isFetching: false,
            });
        case actionTypes.CM_RUN_CALCULATOR_SERVICE_SUCCESS:
        case actionTypes.CM_LEGAL_DISCLAIMER_CHANGED:
        case actionTypes.CM_VALIDATE_ALL_DOCUMENTS_READS_DIRTY:
            partialSteps = updateStep(SECOND_STEP, state.get('steps'), action);
            return state.merge({
                steps: partialSteps,
            });
        case actionTypes.CM_RESET_STEP:
            return state.merge({
                steps: updateStep(
                    action.data.step - 1,
                    state.get('steps'),
                    action,
                ),
            });
        case actionTypes.CM_LEAVE_TRANSFER_MONEY_TO_OTHER_PAGE_CONFIRMED:
        case OKCONSENTS_RESET:
            partialSteps = updateStep(THIRD_STEP, state.get('steps'), action);
            return state.merge({
                steps: partialSteps,
            });
        case actionTypes.CM_ACTIVATE_TRANSFER_MONEY_PRE_LEAVE_MODAL:
            return state.merge({
                preLeaveModalOpen: true,
            });
        case actionTypes.CM_DEACTIVATE_TRANSFER_MONEY_PRE_LEAVE_MODAL:
            return state.merge({
                preLeaveModalOpen: false,
            });
        case actionTypes.FETCH_CM_PORTFOLIO_INFO_REQUEST:
            return state.merge({
                isFetchingPortfolioInfo: true,
            });
        case actionTypes.FETCH_CM_FUNDS_MIN_AMOUNTS_REQUEST:
            return state.merge({
                isFetchingFundsMinAmounts: true,
            });
        case actionTypes.FETCH_CM_PORTFOLIO_RISK_CATEGORIZATION_INFO_REQUEST:
            return state.set('isFetchingRiskCategorizationPortfolio', true);
        case actionTypes.FETCH_CM_FUNDS_MIN_AMOUNTS_SUCCESS:
            const initialPortfolio = state.getIn(['portfolios', 0]);
            const validatedMinAmountsPortfolio = validateMinFundsAmount(
                initialPortfolio.toJS(),
                action.payload.data.response,
                true,
            );

            return state
                .setIn(
                    ['portfolios', 0],
                    Immutable.fromJS(validatedMinAmountsPortfolio.portfolio),
                )
                .merge({
                    minAmounts: action.payload.data.response,
                    isFetchingFundsMinAmounts: false,
                    minAmountsCurrency: action.payload.data.currency,
                    isFundsMinAmountsFetched: true,
                    isMinFundAmountValid: validatedMinAmountsPortfolio.isValid,
                });
        case actionTypes.FETCH_CM_PORTFOLIO_INFO_SUCCESS:
            const filteredPortfolios = filterPortfoliosByType(
                action.payload.data,
                state.getIn(['simulation', 'type']),
            );
            const validatedFunds = validateMinFundsAmount(
                filteredPortfolios[0],
                state.get('minAmounts').toJS(),
                state.get('isFundsMinAmountsFetched'),
            );
            filteredPortfolios[0] = validatedFunds.portfolio;
            const eventTag = getEventTag(
                filteredPortfolios,
                state.getIn(['simulation', 'type']),
                state.getIn(['simulation', 'isDiy']),
            );
            return state.merge({
                isFetchingPortfolioInfo: false,
                isPortfolioInfoFetched: true,
                isMinFundAmountValid: validatedFunds.isValid,
                eventTag: eventTag,
                portfolios: filteredPortfolios,
            });
        case actionTypes.FETCH_CM_PORTFOLIO_INFO_FAILURE:
            return state.merge({
                isFetchingPortfolioInfo: false,
                isPortfolioInfoFetched: true,
            });
        case actionTypes.CM_VALIDATE_PORTFOLIO_ORDER_SUCCESS:
            return state.merge({
                orderValidation: action.payload.data,
            });
        case actionTypes.POST_CM_ORDER_CONFIRMATION_SUCCESS:
            const confirmOrderResultOkOutput =
                action.payload.data.confirmOrderResultOkOutput;
            const isTransferWithMoney = state.getIn([
                'steps',
                FIRST_STEP,
                'isTransferWithMoney',
            ]);
            const emptyConfirmationFundsOK =
                confirmOrderResultOkOutput.length === 0;
            return state.merge({
                submitSuccessful:
                    !emptyConfirmationFundsOK || isTransferWithMoney,
                orderConfirmationSuccessful: confirmOrderResultOkOutput,
                orderConfirmationNotSuccessful:
                    action.payload.data.confirmOrderResultKoOutput,
                errorConfirmation:
                    emptyConfirmationFundsOK && !isTransferWithMoney,
            });
        case actionTypes.POST_CM_FROM_FUNDS_ORDER_CONFIRMATION_IN_PROGRESS:
            return state.merge({
                isFetchingSuccess: true,
            });
        case actionTypes.CM_REMOVE_INTERVENER: {
            const interveners = state.getIn(['steps', 0, 'interveners']);
            let nextInterveners = interveners.splice(action.payload.index, 1);
            const availableInterveners = filterAvailables(
                nextInterveners,
                action.payload.originalInterveners,
            );

            if (nextInterveners.size === 1) {
                nextInterveners = nextInterveners.setIn([0, 'type'], 'TITULAR');
            }

            return state.mergeIn(['steps', 0], {
                interveners: nextInterveners,
                availableInterveners,
            });
        }
        case actionTypes.CM_ADD_INTERVENER: {
            let availableInterveners = state.getIn([
                'steps',
                0,
                'availableInterveners',
            ]);
            if (availableInterveners) {
                const intervener = availableInterveners.get(
                    availableInterveners.size - 1,
                );
                const interveners = state.getIn(['steps', 0, 'interveners']);
                const nextInterveners = interveners.push(intervener);
                availableInterveners = availableInterveners.pop();

                return state.mergeIn(['steps', 0], {
                    interveners: nextInterveners,
                    availableInterveners,
                });
            }
        }
        case actionTypes.CM_SET_INTERVENER_TYPE:
            return updateIntervener(state, get(action, 'payload'));
        case actionTypes.POST_CM_FROM_FUNDS_ORDER_CONFIRMATION_SUCCESS:
            const emptyConfirmationnOK =
                action.payload.data.transferOrderResultOkOutput.length === 0;
            return state.merge({
                isFetchingSuccess: false,
                submitSuccessful: !emptyConfirmationnOK,
                orderConfirmationSuccessful:
                    action.payload.data.transferOrderResultOkOutput,
                orderConfirmationNotSuccessful:
                    action.payload.data.transferOrderResultKoOutput,
                errorConfirmation: emptyConfirmationnOK,
            });
        case actionTypes.CM_SUBMIT_SUCCESSFUL:
            return state.merge({
                submitSuccessful: true,
            });
        case actionTypes.CM_GET_PORTFOLIO_RISK_CATEGORIZATION_SUCCESS:
            return state.mergeDeep({
                walletRisk: {
                    mostRestrictiveIsin: action.payload.mostRestrictiveIsin,
                    riskPortfolioCategorization:
                        action.payload.riskPortfolioCategorization,
                    riskPortfolioMiFid2: action.payload.riskPortfolioMiFid2,
                },
                isFetchingRiskCategorizationPortfolio: false,
                isRiskPortfolioCategorizationFetched: true,
            });
        case actionTypes.CM_VALIDATE_REQUEST:
            partialSteps = updateStep(THIRD_STEP, state.get('steps'), action);
            return state.merge({
                steps: partialSteps,
            });
        case actionTypes.CM_VALIDATE_SUCCESS:
            const typeMoney = state.get('buyType') === CM_BUY_TYPE_MONEY;
            let emptyValidationFundsOK;

            if (!typeMoney) {
                emptyValidationFundsOK =
                    action.payload.data.portfolioOrderValidTransferOk.length ===
                    0;
            } else {
                emptyValidationFundsOK =
                    action.payload.data.validOrderResultOutputOk.length === 0;
            }

            partialSteps = updateStep(THIRD_STEP, state.get('steps'), action);
            return state.merge({
                steps: partialSteps,
                orderValidation: action.payload.data,
                errorValidation: emptyValidationFundsOK,
            });
        case actionTypes.CM_VALIDATE_FAILURE:
            switch (action.payload.step) {
                case WIZARD_FIRST_STEP:
                    partialSteps = updateStep(
                        FIRST_STEP,
                        state.get('steps'),
                        action,
                    );
                    return state.merge({
                        steps: partialSteps,
                        error: action.payload.data.error,
                    });
                case WIZARD_SECOND_STEP:
                    partialSteps = updateStep(
                        SECOND_STEP,
                        state.get('steps'),
                        action,
                    );
                    return state.merge({
                        steps: partialSteps,
                        error: action.payload.data.error,
                    });
            }
            return state;
        case actionTypes.CM_CHANGE_CHECK:
        case actionTypes.CM_SHOW_MESSAGE_ERROR_CHECK:
            partialSteps = updateStep(SECOND_STEP, state.get('steps'), action);
            return state.merge({
                steps: partialSteps,
            });
        default:
            return state;
    }
};

module.exports = cmReducer;
